import api from "api"
import { Subject } from "api/resources/global/types"
import { AfterSignUpData } from "features/Onboarding/types"

import { OnboardingApiAdapter } from "./types"

export const b2bAdapter: OnboardingApiAdapter = {
  saveIsTeachingInSchool: async _value => {
    throw new Error("Method not implemented for B2B flow")
  },

  saveHasExperienceInTeaching: async _value => {
    throw new Error("Method not implemented for B2B flow")
  },

  saveSubjects: async (subjects: Subject[], _isPrimary: boolean) => {
    await api.users.updateOrganizationUser({
      subjectsTaught: subjects.map(s => ({ uuid: s.uuid, name: s.name })),
    })
  },

  createSubject: async (name: string, userUuid: string | undefined) => {
    const result = await api.profile.subjects.createNew({
      data: {
        new: [{ subject: name, user_uuid: userUuid }],
      },
    })
    return result?.[0] ?? null
  },

  saveGrades: async (options: string[], _hasExperience: boolean) => {
    await api.users.updateOrganizationUser({
      gradesTaught: options,
    })
  },

  saveCurricula: async (curricula: string[]) => {
    await api.users.updateOrganizationUser({
      curricula: curricula.map(name => ({ uuid: null, name })),
    })
  },
  saveTeachingLevels: async (levels: string[]) => {
    await api.users.updateOrganizationUser({
      teachingLevels: levels.map(name => ({ uuid: null, name })),
    })
  },

  saveYearsOfExperience: async (_value: number | null) => {
    throw new Error("Method not implemented for B2B flow")
  },

  savePhoneNumber: async (_phoneNumber: string) => {
    throw new Error("Method not implemented for B2B flow")
  },

  saveCurrentLocation: async (
    _location: AfterSignUpData["currentLocation"]
  ) => {
    throw new Error("Method not implemented for B2B flow")
  },

  saveProfilePicture: async (_file: File) => {
    throw new Error("Method not implemented for B2B flow")
  },
}
